// Sant endast i dev-miljön. Dev pekar mot api-dev.foreningssupport.se, prod mot api.foreningssupport.se
// (se azure-pipelines-dev.yml vs azure-pipelines.yml). Fail-closed: matchar inget dev-tecken → döljs (som i prod).
export const isDevEnvironment = (): boolean => (process.env.REACT_APP_API_URL ?? '').includes('api-dev');
